import {
    ArrayTemplate,
    downloadWorkbook,
    exportExcelFromWorkBook,
    RequiredField,
    WorkBookTemplate
} from "../../common/upload/excel.utils";
import {AlertEntity} from "../../handlers/issues-standalone-handler";
import {sendQuery} from "../../common/app-common-utils";
import {RefdataUtils} from "../refdata/refdata-utils";
import {startCase, toLower} from "lodash";

export function downloadAlertsAsExcel(alerts: AlertEntity[]) {
    sendQuery("getConnectionsAsEntities").subscribe(result => {
        const data = prepareData(alerts, result);
        return exportExcelFromWorkBook(downloadWorkbook("/assets/templates/alerts-template.xlsx"),
            alertsTemplate, data, "alerts-export.xlsx");
    });
}

function prepareData(alerts: AlertEntity[], refdata: any[]) {
    return {
        alerts: alerts.map(a => ({
            organisation: refdata.find(c => c.connection.connectionId === a.alert.details.entityIds[1])?.organisation.info.name,
            location: RefdataUtils.addressFormatter(refdata.find(c => c.connection.connectionId === a.alert.details.entityIds[1])?.location.info.address),
            ean: refdata.find(c => c.connection.connectionId === a.alert.details.entityIds[1])?.connection.info.code,
            alertId: a.alert.alertId,
            meterId: a.alert.details.entityIds[0],
            type: startCase(a.alert.details.type),
            timestamp: formatTimestamp(a.alert.timestamp),
            status: a.alert.alertStatus,
            connectionType: a.alert.connectionType,
            surveyor: a.alert.surveyor,
            meterType: startCase(toLower(a.alert.meterType?.replace(/_/g, ' '))),
            message: a.alert.details.message,
            user: a.alert.assigneeId,
            note: a.alert.note,
        }))
    }
}

const alertInfoTemplate = {
    organisation: new RequiredField('A$'),
    location: new RequiredField('B$'),
    ean: new RequiredField('C$'),
    alertId: new RequiredField('D$'),
    meterId: new RequiredField('E$'),
    type: new RequiredField('F$'),
    timestamp: new RequiredField('G$'),
    status: new RequiredField('H$'),
    connectionType: new RequiredField('I$'),
    surveyor: new RequiredField('J$'),
    meterType: new RequiredField('K$'),
    message: 'L$',
    user: 'M$',
    note: 'N$'
};


const alertsTemplate: WorkBookTemplate = {
    sheets: [
        {
            name: 'Alerts',
            template: {
                alerts: new ArrayTemplate(alertInfoTemplate, [2, 20000])
            }
        }
    ]
}

function formatTimestamp(isoString: string): string {
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return '';

    return date.toLocaleString('nl-NL', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC'
    });
}
